import { render, staticRenderFns } from "./VMissingDays.vue?vue&type=template&id=840f6562&"
import script from "./VMissingDays.vue?vue&type=script&lang=js&"
export * from "./VMissingDays.vue?vue&type=script&lang=js&"
import style0 from "./VMissingDays.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports